import { React, useState, useEffect } from 'react';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Divider,
  Box,
  Typography,
  LinearProgress,
  useMediaQuery
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import PropTypes from 'prop-types';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontFamily: 'Helvetica Neue',
    color: fade('#bdbdbd', 1),
  },
  sectionTwo: {
    backgroundColor: "#282828",
    paddingLeft: 20,
    paddingRight: 20,

  },
  innerGridContainer: {
    width: "100%",
    margin: "0px",
    padding: "15px"
  },
  innerGridHeading: {
    width: "100%",
    textAlign: "center",
    color: "#FFF",
    fontSize: "3rem"
  },
  innerGridHeadingMobile: {
    width: "100%",
    textAlign: "center",
    fontSize: '2.5rem',
    color: fade('#bdbdbd', 1),
    paddingLeft: 20,
    paddingRight: 20,
  },
  subParagraph: {
    margin: "20px 0px",
    fontSize: '1.2rem',
    width: "100%",
    textAlign: "center",
  },
  progressBarDesign: {
    minHeight: 45,
    marginBottom: 15,
    backgroundColor: '#FFF',

  }
}));

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress color="primary" variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="#FFF">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const StyledLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: "white"
  },
  barColorPrimary: {
    backgroundColor: "#ef6c00"
  },
})(LinearProgressWithLabel);

export default function Home() {
  const classes = useStyles();
  const [progress, setProgress] = useState(10);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={classes.root}>
      <section className={classes.sectionTwo}>
        <Grid className={classes.innerGridContainer}
          container
          spacing={2} >
          <Grid xs={12}>
            <h2 className={isMobile ? classes.innerGridHeading : classes.innerGridHeadingMobile} >Lydbranding – dokumenteret effekt</h2>
            <Divider style={{ margin: 'auto', height: '2px', width: '60px', backgroundColor: "#FFF" }} />
            <br />
            <p className={classes.subParagraph}>
              Musik og Lydbranding har på mange parametre en positiv og målbar effekt. <br />
              Udover at kunne være med til øge besøgstiden i en butik, har det også en <br />
              dokumenteret positiv effekt på velværeren og atmosfæren i butikken. <br /><br />
              Herudover kan lydbranding øge effekten på følgende parametre:
            </p>
          </Grid>
          <Grid xs={12} md={6} style={{ color: "#FFF", padding: 40 }}>
            <h6 >GENKENDELIGHED</h6>
            <StyledLinearProgress className={classes.progressBarDesign} value={96} />
            <h6>MEMORERING</h6>
            <StyledLinearProgress className={classes.progressBarDesign} value={75} />
            <h6>POSITIONERING</h6>
            <StyledLinearProgress className={classes.progressBarDesign} value={25} />
          </Grid>
          <Grid xs={12} md={6} style={{ color: "#FFF", padding: 40 }}>
            <h6>SYNERGIEFFEKT</h6>
            <StyledLinearProgress className={classes.progressBarDesign} value={100} />
            <h6>KOBSFREKVENS</h6>
            <StyledLinearProgress className={classes.progressBarDesign} value={24} />
            <h6>KBOSVOLUMEN</h6>
            <StyledLinearProgress className={classes.progressBarDesign} value={38} />
          </Grid>
        </Grid>

      </section>
    </div>
  )
}